import axios from 'axios'

export const changeFollowingStatus = (tagID: string | undefined | null, follow: boolean) => {
  return axios.put(`/tag/${tagID}?follow=${follow}`)
}
